module.exports = __webpack_public_path__ + "img/1.deff4da5.jpg";